export type ContactAgreementValues = (typeof contactAgreementValues)[number];

// PTS-287: tylko "enabled" — "disabled" natychmiast wycofałby w Synerise zgodę daną wcześniej na ten profil.
export const contactAgreementValues = ["enabled"] as const;

export const dntCookieName = "_snrs_dnt";

export const dntCookieOptions = {
  expires: 365,
} as const;

export const srVendorName = "Synerise";

// CMP purpose id gating Synerise tracking (c2 = marketing). Synerise is listed under marketing in
// the CMP banner, and Synerise's DNT guide says to enable DNT when the visitor rejects the category
// Synerise belongs to. We read purpose consent (not vendor consent) because the SR vendor is
// always-on in CMP: the SDK has to load so Dynamic Content still renders in DNT mode.
export const srPurposeId = "c2";

export const SYNERISE_HEALTH_TIMEOUT_MS = 5_000;
